import React from 'react';
import { Link } from 'react-router-dom';
import logo from './assets/OS logo inverted.png';
import './EventsPage.css';

function EventsPage() {
  return (
    <div className="EventsPage">
      <header className="Events-header">
        <Link to="/" className="logo-link">
          <img src={logo} className="Events-logo" alt="logo" />
        </Link>
        <h1>Events</h1>
        
        <div className="coming-soon">
          <p>Coming Soon</p>
        </div>

        <Link to="/" className="back-link">
          ← Back to Sessions
        </Link>
      </header>
    </div>
  );
}

export default EventsPage;
